// only allow these values for ENVIRONMENT, otherwise abort
const allowedEnvironmentValues = [
  'test-automation',
  'development',
  'staging',
  'production',
]

// Determine 'test-automation' environment automatically if NODE_ENV is 'test'
const testAutomation =
  process.env.NODE_ENV === 'test' ? 'test-automation' : undefined
const rawEnvironment = (process.env.ENVIRONMENT ?? testAutomation)
  ?.trim()
  .toLowerCase()
if (
  !rawEnvironment ||
  !allowedEnvironmentValues.includes(rawEnvironment || '')
) {
  throw new Error(
    `Invalid environment value: ${
      process.env.ENVIRONMENT
    }. Must be one of ${allowedEnvironmentValues.join(', ')}`,
  )
}

export const ENVIRONMENT = rawEnvironment as
  | 'test-automation'
  | 'development'
  | 'staging'
  | 'production'

// Mock API URL for E2E tests - must match between Playwright tests and React app
// No real server should run here to ensure all requests use mocks
export const E2E_API_BASE_URL = 'http://localhost:56789/api/mofi-payments'

export const API_BASE_URL =
  ENVIRONMENT === 'test-automation'
    ? E2E_API_BASE_URL
    : process.env.API_BASE_URL

export const SENTRY_DSN = process.env.SENTRY_DSN
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE
export const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_TRACES_SAMPLE_RATE || '0',
)

const sentryTracePropagationTargets =
  process.env.SENTRY_TRACE_PROPAGATION_TARGETS?.split(',').map((target) => {
    return new RegExp(target.trim())
  })

export const SENTRY_TRACE_PROPAGATION_TARGETS = sentryTracePropagationTargets

export const SENTRY_REPLAY_SESSION_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_REPLAY_SESSION_SAMPLE_RATE || '0',
)
export const SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE || '0',
)
export const SENTRY_DEBUG = process.env.SENTRY_DEBUG === 'true'
